import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BreadCrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { FormContainer } from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import { httpGetCompanyForm } from '../../../Hooks/company/company.get.hooks';
import InputTextNested from '../../../Components/Form/InputTextNested';
import TextAreaNested from '../../../Components/Form/TextAreaNexted';
import EditFormButton from './FormEditSubmit.component';
import AuthCheckManager from '../../../Utils/AuthCheck/ManagerCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
// import EditPDFViewer from './EditPdf.component';
const EditForm = () => {
  const { id, formId } = useParams();
  const [form, setForm] = useState([]);

  useEffect(() => {
    const GetForm = async () => {
      const res = await httpGetCompanyForm(id, formId);
      setForm(res[0]);
    };
    GetForm();
  }, [formId, id]);

  return (
    <AuthCheckManager>
      <HelmetHelper title="Edit Form" description="Edit a form" />
      <FormContainer>
        <BreadCrumbs
          one="Company Dashboard"
          oneLink="/company"
          two="Edit Form"
        />
        <h2>EDIT FORM</h2>
        {/* <EditPDFViewer pdfUrl={form.url} /> */}
        <form>
          {/* The forms name */}
          <InputTextNested
            title="Form Name"
            placeholder="Enter the form name"
            value={form.name}
            nestedValue={setForm}
            upperValue={form}
            name="name"
          />
          {/* The forms description */}
          <TextAreaNested
            title="Form Description"
            placeholder="Enter the form description"
            value={form.description}
            nestedValue={setForm}
            upperValue={form}
            name="description"
          />
          <EditFormButton formData={form} />
        </form>
      </FormContainer>
    </AuthCheckManager>
  );
};

export default EditForm;
